module.exports = __webpack_public_path__ + "img/motorcycle-photo-04.60911439.jpg";